import { createAction, props } from '@ngrx/store';
import type { IOverviewResponse, OverviewTypes } from '@candyland/generic/tt-com-shared-overviews';

export interface LoadOverviewActionPayload {
  storeId: string;
  overviewId: string;
  category: string;
  display: 'mobile' | 'desktop' | string;
  page?: string;
  queryParams?: { [key: string]: string };
}

export const unselectOverview = createAction('[Overview] Unselect Overview', props<any>());

export const selectOverview = createAction('[Overview] Select Overview', props<LoadOverviewActionPayload>());

export const loadOverview = createAction('[Overview] Load Overview', props<LoadOverviewActionPayload>());

export const loadOverviewSuccess = createAction(
  '[Overview] Loaded Success',
  props<{ storeId: string; page: string; overview: IOverviewResponse; fetchDate: Date }>()
);

export const loadOverviewFailure = createAction(
  '[Overview] Loaded Failure',
  props<{
    storeId: string;
    overviewId: string;
    overviewType: OverviewTypes;
    page: string;
    statusCode: number;
    message: string;
  }>()
);

export const refreshOverview = createAction('[Overview] Refresh', props<any>());
